import { bizchatSidepaneStore } from '../store/store';
import { getBizchatLoadedKey } from '../utils/getBizchatLoadedKey';
import type { MailboxInfo } from 'owa-client-types';
import type { WindowKey } from 'owa-bizchat-types';

export function shouldShowLoadingUi(mailboxInfo: MailboxInfo, windowKey: WindowKey): boolean {
    const key = getBizchatLoadedKey(mailboxInfo, windowKey);
    return !bizchatSidepaneStore().isBizchatSidepaneLoadedMap.get(key);
}
